<template>
  <v-switch
    :disabled="disabled"
    class="v-switch--label-left my-0"
    v-model="geolocationSwitchData"
    true-value="1"
    false-value="0"
    color="primary"
    density="compact"
    inset
    hide-details
    :label="$t('mission-planning.qst.info-pos.label.present-in-pos')"
    @update:model-value="setPresence()"
  ></v-switch>
</template>

<script setup>
import { inject, ref } from 'vue'
import { createReadingIfNotExists } from '@/stores/manager/readingManager'
import { saveReadingCountersDebounced } from '@/stores/manager/conditionsManager'
import { ConditionsController } from '@/utils/conditions/conditionsController'
import { useStoreManager } from '@/stores/storeManager'

const props = defineProps({
  reading: {
    type: Object,
    required: false,
    default: {}
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false
  }
});
const storeManager = useStoreManager();
const currentMissionPlanningId = inject('currentMissionPlanningId')
const userDetails = inject('userDetails')
const currentConfiguration = inject('currentConfiguration')
const currentPointOfSale = inject('currentPointOfSale')
const currentReadingId = inject('currentReadingId')

const geolocationSwitchData = ref(props.reading?.data?.isPresentDate || false ? '1' : '0')

const setPresence = async () => {
  const geolocationData = props.reading?.data || currentConfiguration.value?.data || {}
  conditionallyResetGeoLocationData(geolocationData)
  conditionallySetGeoLocationData(geolocationData)
}

const conditionallyResetGeoLocationData = (geolocationData) => {
  if (geolocationSwitchData.value === '1' || !currentReadingId.value) {
    return
  }
  geolocationData.isPresentDate = null
  geolocationData.latitude = null
  geolocationData.longitude = null
  props.reading.data = geolocationData;
  storeManager.update('reading', 'reading', currentReadingId.value, props.reading);
}

const handleGeolocationSuccess = async (pos, geolocationData) => {
  const crd = pos.coords
  geolocationData.latitude = crd.latitude || null
  geolocationData.longitude = crd.longitude || null
  if (!currentReadingId.value) {
    const readingId = await createReading(geolocationData)
    launchUpdateConditions(readingId)
  } else {
    props.reading.data = geolocationData
    storeManager.update('reading', 'reading', currentReadingId.value, props.reading)
  }
}

const handleGeolocationError = async (err, geolocationData) => {
  console.log('Geolocation error:', err)
  geolocationData.latitude = null
  geolocationData.longitude = null

  if (!currentReadingId.value) {
    const readingId = await createReading(geolocationData)
    launchUpdateConditions(readingId)
  } else {
    props.reading.data = geolocationData
    storeManager.update('reading', 'reading', currentReadingId.value, props.reading)
  }
}

const conditionallySetGeoLocationData = (geolocationData) => {
  if (geolocationSwitchData.value === '0') {
    return
  }
  const geoLocationOptions = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0
  }
  geolocationData.isPresentDate = new Date().toISOString().replace('T', ' ').substring(0, 19);
  navigator.geolocation.getCurrentPosition(
    (pos) => handleGeolocationSuccess(pos, geolocationData),
    (err) => handleGeolocationError(err, geolocationData),
    geoLocationOptions
  )
}

function launchUpdateConditions(readingId) {
  let initialContext = {
    currentValue: null,
    answers: [],
    pos: currentPointOfSale.value,
    attachementType: 'none',
    attachementId: null,
    prod: null,
    nowDatetime: new Date()
  }
  const conditionCalculatorInstance = new ConditionsController(
    currentConfiguration.value,
    initialContext,
    readingId
  );
  conditionCalculatorInstance.createConditions();
  saveReadingCountersDebounced(readingId, currentConfiguration.value)
}

const createReading = async (data) => {
  return await createReadingIfNotExists(
    '',
    currentConfiguration.value?.id,
    currentMissionPlanningId.value || null,
    userDetails.value.id,
    data
  )
}
</script>
